var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-polls-container"},[_c('vote-loader',{staticClass:"loader"}),_c('div',{staticClass:"message-info"},[_c('div',[_vm._v(_vm._s(_vm.$t('TXT.WALL.NO_ACTIVE_POLL')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }